"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _TheaterInfo = require("./TheaterInfo");
Object.keys(_TheaterInfo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TheaterInfo[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _TheaterInfo[key];
    }
  });
});